module.exports = __webpack_public_path__ + "static/media/ETS_Video250x310.d5826629.mp4";